//THIS IS REQUIRED BECAUSE Auth.js & reducer/index.js
// ARE INTER-DEPANDENT
//ONLY FOR BROWSER REFRESH

const checkIfLogged = () => {
    
    const usr = {
        status: false,
        name: null,
    }
    if (sessionStorage.getItem('loggedUser') !== null){
        usr.status = true;
        usr.name = sessionStorage.getItem('loggedUser');
    }
    return usr;
}

export default checkIfLogged;